<template>
  <div class="edit-song">
    <div class="suc-alert" v-show="alertShow">
      <div class="alert">
        <div class="header">
          <div class="close" @click="gotoWork">x</div>
        </div>
        <div class="content">
          <div style="font-size:18px;font-weight:bold;margin-bottom:10px">提交成功，请耐心等待审核</div>
          <div>审核时间大约48小时。</div>
        </div>
        <div class="footer">
          <div class="btn"  @click="gotoWork">知道了</div>
        </div>
      </div>
    </div>
    <audio :src="uploadSortArr[0] && uploadSortArr[0].url" id="editSongAudio" style="display:none"></audio>
    <header>
      <div class="btn_area center-y">
        <div
          class="blue_btn common_blue_type_btn upload_song_btn"
          id="uploadBtn"
          v-show="isuploading == false && uploadSortArr.length == 0"
        >
          上传歌曲
        </div>
        <div
          class="gray_btn common_blue_type_btn upload_song_btn"
          v-show="isuploading == true && uploadSortArr.length == 0"
        >
          上传中
        </div>
      </div>
      <div
        v-for="(item, index) in uploadSortArr"
        :key="item.audio_group_id"
        :class="[item.edit_form_show ? 'current song' : 'song']"
      >
        <div class="list_content">
          <div class="fm_info">
            <span>{{ index + 1 }}</span>
            <span id="playSong" class="play" v-show="item.url" @click="playSong"></span>
            {{ item.audio_name }}
          </div>
          <div class="fm_progress" v-if="item.progress == 'progress'">
            <div class="progress_bg">
              <div
                class="progress"
                :style="{ width: item.percentage + '%' }"
              ></div>
            </div>
            <span>上传{{ item.percentage }}%</span>
          </div>
          <div class="fm_progress fail" v-else-if="item.progress == 'fail'">
            上传失败
            <!-- <a
              style="margin-left: 20px;color:#888"
              href="javascript:;"
              class="delete"
              @click="songListDelete"
              >删除</a
            > -->
          </div>
          <div class="fm_progress" v-else-if="item.progress == 'completed'">
            已上传
          </div>
          <div class="fm_progress" v-else></div>

          <div class="fm_handle">
            <!-- <a
              v-if="item.progress == 'completed'"
              href="javascript:;"
              class="edit"
              @click="editSongToggle(index)"
            >
              编辑
              <i class="icon icon_arrow_up_v2" v-if="item.edit_form_show"></i>
              <i class="icon icon_arrow_down_v2" v-else></i>
            </a> -->
            <a
              href="javascript:;"
              class="delete"
              v-show="isuploading == false"
              @click="songListDelete"
              >删除</a
            >
            <i class="icon icon_songlist_drag icon_drag"></i>
          </div>
        </div>
      </div>
    </header>
    <div class="main">
      <div class="edit">
        <div class="row">
           <div style="font-size: 14px;color: #888888;">
              <p>酷狗Remix音乐人发布后的歌曲仅在酷狗音乐上架，</p>
              <p>如需同步上架五大曲库（酷狗音乐、QQ音乐、酷我音乐、全民K歌、酷狗唱唱），请先认证原创/翻唱音乐人。<a style="color:#0090ff;text-decoration:underline" target="_blank" href="https://www.kugou.com/imusic/static/html/home.html?djfrom=origin">去认证 ></a></p>
            </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">歌曲名</div>
          </div>
          <div class="right">
            <input class="text" v-model="songName" maxlength="60" @blur="checkSongName(songName)"/>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y"></div>
          </div>
          <div class="right">
            <div class="tip">
              <p>1.如果您参与了演唱，则歌曲名不需要带歌手名，如果您仅参与编曲，请按以下格式填写  原唱-歌曲名（DJ版）</p>
              <p>2.如有备注请使用括号，例：歌曲名 (三周年主题曲)</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">曲风</div>
          </div>
          <div class="right">
            <el-select v-model="audioStyle" placeholder="请选择">
              <el-option
                v-for="item in audioStyleArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">版本</div>
          </div>
          <div class="right">
            <el-select v-model="version" placeholder="请选择">
              <el-option
                v-for="item in songVersionArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">歌手</div>
          </div>
          <div class="right">
            <input class="text input-disabled" v-model="authorName" disabled />
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">作词</div>
          </div>
          <div class="right">
            <input
              class="text"
              placeholder="请输入作词人姓名"
              v-model="lyrics"
              maxlength="60"
              @blur="checkName(lyrics, 'lyrics')"
            />
            <el-checkbox v-model="lyricsChecked">我是作词人</el-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="left">
            <div class="label center-y">作曲</div>
          </div>
          <div class="right">
            <input
              class="text"
              placeholder="请输入作曲人姓名"
              v-model="composer"
              maxlength="60"
              @blur="checkName(composer, 'composer')"
            />
            <el-checkbox v-model="composerChecked">我是作曲人</el-checkbox>
          </div>
        </div>

        <div class="row">
          <div class="left">
            <div class="label center-y"></div>
          </div>
          <div class="right">
            <div class="btn submit" @click="submitSong">提交</div>
            <div class="btn back" @click="back">返回</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import audioStyleArr from "../data/audio_style.json";
import songVersionArr from "../data/song_version.json";
import { checkName, checkSongName } from "../lib/sensitive"
export default {
  watch: {
    authorName(val) {
      if (this.lyricsChecked) this.lyrics = val;
      if (this.composerChecked) this.composer = val;
    },
    composer(val) {
      if (this.composerChecked) {
        this.composer = this.authorName;
      }
    },
    lyrics(val) {
      if (this.lyricsChecked) {
        this.lyrics = this.authorName;
      }
    },
    lyricsChecked(val) {
      if (val) {
        if (!this.authorName) {
          window.eventEmitter.emit("toast", "请输入歌手名");
          this.lyricsChecked = false;
          return;
        } else {
          this.lyrics = this.authorName;
        }
      }
    },
    composerChecked(val) {
      if (val) {
        if (!this.authorName) {
          window.eventEmitter.emit("toast", "请输入歌手名");
          this.composerChecked = false;
        } else {
          this.composer = this.authorName;
        }
      }
    },
  },
  data() {
    return {
      songName: "",
      authorName: "",
      lyrics: "",
      composer: "",
      songVersionArr: songVersionArr,
      version: 2,
      audioStyleArr: audioStyleArr,
      audioStyle: 101,
      uploadSortArr: [],
      isuploading: false,
      lyricsChecked: false,
      composerChecked: false,
      checkInfo: true,
      checkSongNameFlag: true,
      checkInfo_lyrics: true,
      checkInfo_composer: true,
      agreeChecked: false,
      alertShow: false
    };
  },
  mounted() {
    console.log(this.$route.params.id);
    if (!this.$route.params.id) {
      //新建
      this.myStatus();
    } else {
      this.api({
        apiName: "songDetail",
        methods: "GET",
        getData: {
          biz: "musician_song_dj",
          id: this.$route.params.id,
        },
      }).then((res) => {
        console.log(res);
        const data = res.data.info;
        this.songName = data.song_name;
        this.audioStyle = data.audio_style;
        this.version = data.version;
        this.authorName = data.author_name;
        this.composer = data.composer;
        this.lyrics = data.lyrics;
        this.uploadSortArr[0] = {
          hash: data.song_hash,
          audio_name: data.song_name,
          progress: "completed",
        };
        this.getSongURL(data.song_hash)
      });
    }
    let _t = this;

    $(document).ready(function () {
      kgUploader.init(
        {
          id: $("#uploadBtn"),
          auto: true,
          multiple: false,
        },
        (err) => {
          console.log("warn", err);
          window.eventEmitter.emit('toast', err)
          _t.resetUploadComponent()
        }
      );

      _t.kgUploaderSet();

      kgUploader.clearFiles();
    });
  },
  methods: {
    resetUploadComponent() {
      kgUploader.init(
        {
          id: $("#uploadBtn"),
          auto: true,
          multiple: false,
        },
        function (err) {
          console.log("warn", err);
          window.eventEmitter.emit('toast', err)
          this.resetUploadComponent()
        }
      );

      this.kgUploaderSet();

      kgUploader.clearFiles();
    },
    gotoWork() {
      this.$router.push("/work");
    },
    //检测
    async checkSongName(word) {
      if(!await checkSongName(word)) {
        this.checkSongNameFlag = false
      } else {
        this.checkSongNameFlag = true
      }
    },
    async checkName(word, flag) {
      if(!await checkName(word)) {
        this[`checkInfo_${flag}`] = false
      } else {
        this[`checkInfo_${flag}`] = true
      }
    },
    //播放
    playSong() {
      //点击播放
      if(document.getElementById('playSong').getAttribute('class') == 'play') {
        document.getElementById('editSongAudio').play()
        document.getElementById('playSong').setAttribute('class', 'pause')
      } else {
        document.getElementById('editSongAudio').pause()
        document.getElementById('playSong').setAttribute('class', 'play')
      }
    },
    //获取歌曲URL
    getSongURL(hash) {
      this.api({
        apiName: "songURL",
        methods: "GET",
        getData: {
          biz: "musician_song_dj",
          field: "song_hash",
          file: hash,
        },
      }).then((res) => {
        console.log(res);
        const url = res.data.url;
        this.uploadSortArr.splice(0, 1, Object.assign(this.uploadSortArr[0], {
          url: url
        }))
      });
    },
    //获取我的状态
    myStatus(cb) {
      this.api({
        apiName: "myStatus",
        methods: "GET",
        getData: {
          biz: "musician_author_dj",
        },
      }).then((res) => {
        const data = res.data;
        //没入驻过
        if (!data.info) {
          this.$router.push("/enter");
        } else {
          this.authorName = data.info.author_name;
        }
      });
    },
    songListDelete() {
      const _t = this;
      this.uploadSortArr = [];
      kgUploader.init(
        {
          id: $("#uploadBtn"),
          auto: true,
          multiple: false,
        },
        (err) => {
          console.log("warn", err);
          window.eventEmitter.emit('toast', err)
          _t.resetUploadComponent()
        }
      );

      this.kgUploaderSet();

      kgUploader.clearFiles();
    },
    back() {
      this.$router.push("/work");
    },
    submitSong() {
      // //协议
      // if (!this.agreeChecked) return this.eventEmitter.emit("toast", "请阅读平台协议，并同意");
      if (!this.checkField()) return;
      if(this.uploadSortArr[0].progress != 'completed') return window.eventEmitter.emit("toast", "请上传完歌曲再进行提交");

      //上报
      window.statisticInfo.BiStatistic = {
        appid: window.appid, //appId
        userid: window.kugouid, //用户id
        mid: window.mid, //mid
        a: 23297, //BI-a
        b: "点击", //BI-b
        ft: "音乐人入驻", //BI-ft
        r: "提交作品按钮", //BI-r
        'channel': 'WEB'
      };
      window.mobileLog(30050, window.statisticInfo.BiStatistic, null, 0);

      const data = {
        song_name: this.songName,
        audio_style: this.audioStyle,
        version: this.version,
        author_name: this.authorName,
        lyrics: this.lyrics,
        composer: this.composer,
        song_hash: this.uploadSortArr[0].hash,
        biz: "musician_song_dj",
        userid: window.kugouid,
        token: window.token,
        appid: window.appid,
        is_submit: 1,
      };
      let apiName = "";
      //修改
      if (this.$route.params.id) {
        data.id = this.$route.params.id;
        apiName = "updateSong";
      } else {
        apiName = "createSong";
      }
      this.api({
        apiName: apiName,
        postData: data,
      })
        .then((res) => {
          console.log(res);
          this.alertShow = true
        })
        .catch((err) => {
          if(err.errcode >= 40100 && err.errcode <= 40199) {
            window.eventEmitter.emit("toast",'上传歌曲错误，请重新上传');
            this.uploadSortArr = []
          }
          else window.eventEmitter.emit("toast", err.error || '服务器异常');
        });
    },
    checkField() {
      if( !this.checkSongNameFlag) {
        window.eventEmitter.emit("toast", "歌曲名请不要输入特殊符号");
        return false;
      }
      if( !this.checkInfo_lyrics || !this.checkInfo_composer) {
        window.eventEmitter.emit("toast", "姓名请不要输入特殊符号");
        return false;
      }
      if (this.uploadSortArr.length == 0) {
        window.eventEmitter.emit("toast", "请上传歌曲");
        return false;
      }
      if (!this.songName.trim()) {
        window.eventEmitter.emit("toast", "请填写歌曲名");
        return false;
      }
      if (!this.authorName.trim()) {
        window.eventEmitter.emit("toast", "请填写歌手名");
        return false;
      }
      if (!this.lyrics.trim()) {
        window.eventEmitter.emit("toast", "请填写作词人");
        return false;
      }
      if (!this.composer.trim()) {
        window.eventEmitter.emit("toast", "请填写作曲人");
        return false;
      }
      return true;
    },
    /**
     * 上传设置
     */
    kgUploaderSet() {
      let _t = this;

      /**
       * 返回当前上传歌曲
       * @param {Object} file
       * @param {Object} index
       */
      function reurnCurrentSong(file_hash, index) {
        for (let i = 0; i < _t.uploadSortArr.length; i++) {
          if (_t.uploadSortArr[i].hash == file_hash) {
            return {
              data: _t.uploadSortArr[i],
              index: i,
            };
            break;
          }
        }
        return {};
      }

      /**
       * 去重当前上传歌曲
       * @param {Object} file
       * @param {Object} index
       */
      function removeCopyArr() {
        // console.log(_t.uploadSortArr)
        for (var i = 0; i < _t.uploadSortArr.length; i++) {
          for (var j = i + 1; j < _t.uploadSortArr.length; j++) {
            if (_t.uploadSortArr[i]["hash"] === _t.uploadSortArr[j]["hash"]) {
              _t.uploadSortArr.splice(j, 1);
              break;
            }
          }
        }
      }

      /**
       * 去除当前当前不符合后缀名上传歌曲
       * @param {Object} file
       * @param {Object} index
       */
      function removeExtFileArr() {
        // console.log(_t.uploadSortArr)
        for (var i = 0; i < _t.uploadSortArr.length; i++) {
          var extIndex = _t.uploadSortArr[i].file.name.lastIndexOf(".");
          var extName = _t.uploadSortArr[i].file.name
            .substr(extIndex + 1)
            .toLowerCase();
          if (
            extName !== "mp3" &&
            extName !== "m4a" &&
            extName !== "ape" &&
            extName !== "flac" &&
            extName !== "wav" &&
            extName !== "dsf" &&
            extName !== "dff" &&
            extName !== "wma" &&
            extName !== "dts" &&
            extName !== "ogg" &&
            extName !== "tac" &&
            extName !== "acc" &&
            extName !== "aac"
          ) {
            _t.uploadSortArr.splice(i, 1);
            break;
          }
        }
      }

      kgUploader.on("queued", function (files, repeatListArr) {
        console.log("_t.uploadSortArr", _t.uploadSortArr);
        var cacheUploadSortArr = JSON.parse(JSON.stringify(_t.uploadSortArr));
        // console.log(cacheUploadSortArr)

        if (Array.isArray(repeatListArr)) {
          if (repeatListArr.length > 0) {
            console.log(repeatListArr);
            window.eventEmitter.emit("toast", "请勿重复上传相同节目");
          }
        }

        var lenArr = [];
        if (Array.isArray(files)) {
          // console.log(files)

          for (var i = 0; i < files.length; i++) {
            /*文件格式校验提示*/
            var extIndex = files[i].file.name.lastIndexOf(".");
            var extName = files[i].file.name.substr(extIndex + 1).toLowerCase();
            if (
              extName !== "mp3" &&
              extName !== "m4a" &&
              extName !== "ape" &&
              extName !== "flac" &&
              extName !== "wav" &&
              extName !== "dsf" &&
              extName !== "dff" &&
              extName !== "wma" &&
              extName !== "dts" &&
              extName !== "ogg" &&
              extName !== "tac" &&
              extName !== "acc" &&
              extName !== "aac"
            ) {
              window.eventEmitter.emit(
                "toast",
                files[i].file.name + "文件格式不支持，请更换格式后再上传"
              );
            }
            /*文件格式校验提示*/

            var resultArr = false;
            for (var n = 0; n < cacheUploadSortArr.length; n++) {
              /*第二次选择（init之后）的去重*/
              if (files[i].file_hash === cacheUploadSortArr[n].hash) {
                // _t.isuploading = false;
                resultArr = true;
                // showTotas('warn', '请勿重复上传相同节目');
                break;
              }
            }
            if (!resultArr) {
              // _t.isuploading = true;
              lenArr.push({
                audio_name: files[i].file.name.replace(
                  /\.MP3|\.M4A|\.APE|\.FLAC|\.WAV|\.DSF|\.DFF|\.WMA|\.DTS|\.OGG|\.TAC|\.ACC|\.AAC/gi,
                  ""
                ),
                edit_song_name: files[i].file.name.replace(
                  /\.MP3|\.M4A|\.APE|\.FLAC|\.WAV|\.DSF|\.DFF|\.WMA|\.DTS|\.OGG|\.TAC|\.ACC|\.AAC/gi,
                  ""
                ),
                author_name: _t.username,
                id: 0,
                edit_form_show: false,
                publishTimeChoose: 1,
                percentage: 0,
                file: files[i].file,
                introduce: "",
                publish_time: "",
                hash: files[i].file_hash,
                progress: "progress",
                status: 0, //是否已经上传  0 未上传 | 1 已上传
              });
            }
          }
          // console.log(_t.uploadSortArr)
          // _t.uploadSortArr = lenArr.concat(_t.uploadSortArr)
          _t.uploadSortArr = _t.uploadSortArr.concat(lenArr);
        }
      });

      kgUploader.on("fail", function (file, hash, action) {
        console.log("fail");
        let data = reurnCurrentSong(file.file_hash).data,
          index = reurnCurrentSong(file.file_hash).index;
        data.progress = "fail";
        _t.isuploading = false;
      });

      kgUploader.on("uploadStart", function (file) {
        console.log("uploadStart");
        // console.log(_t.uploadSortArr.length)
        // console.log(_t.uploadSortArr)
        // console.log(file)
        _t.isuploading = true;
        var name = file.name;
      });

      kgUploader.on("beforeFileQueued", function (file, callback) {
        console.log("beforeFileQueued");
        var name = file.name,
          same = false;

        for (let i = 0; i < _t.uploadSortArr.length; i++) {
          if (_t.uploadSortArr[i].audio_name == file.name) {
            same = true;
            break;
          }
        }
        if (same) {
          callback && callback(false);
        } else {
          callback && callback(true);
        }
      });

      kgUploader.on("uploading", function (file, percentage) {
        console.log("uploading");
        console.log(file)
        let name = file.file.name,
          data = reurnCurrentSong(file.file_hash).data;
        data.progress = "progress";
        data.percentage = parseInt(percentage);
      });

      kgUploader.on("success", (file) => {
        console.log("success");
        let data = reurnCurrentSong(file.file_hash).data;
        console.log("uploaddata", data);
        data.hash = file.file_hash;

        data.status = 1;
        data.progress = "completed";

        this.getSongURL(data.hash)
      });

      kgUploader.on("complete", function () {
        console.log("complete");
        _t.isuploading = false;
        removeCopyArr();
        removeExtFileArr();
        // console.log(_t.uploadSortArr)
        console.log("全部文件上传完成");

        kgUploader.init(
          {
            id: $("#uploadBtn"),
            auto: true,
            multiple: false,
          },
          function (err) {
            console.log("warn", err);
            window.eventEmitter.emit('toast', err)
            this.resetUploadComponent()
          }
        );

        _t.kgUploaderSet();

        kgUploader.clearFiles();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/common.scss";
.edit-song {
  width: calc(100vw - 60px);
  height: calc(100vh - 35px);
  padding-left: 60px;
  padding-top: 30px;
  background: #fff;
  border-radius: 10px;
  position: relative;
  .suc-alert {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    z-index: 999999;
    .alert {
      background: #fff;
      width: 400px;
      border: 1px solid #ccc;
      .header {
        width: 100%;
        height: 35px;
        line-height: 35px;
        background-color: #000;
        position: relative;
        .close {
          width: 13px;
          height: 13px;
          position: absolute;
          right: 10px;
          color: #fff;
          cursor: pointer;
        }
      }
      .content {
        flex-direction: column;
        height: auto;
        min-height: 60px;
        text-align: center;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
      }
      .footer {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;
        .btn {
          width: 100px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          background-color: #0090ff;
          color: #fff;
          text-align: center;
        }
      }
    }
  }
  .input-disabled {
    background: rgba(0, 0, 0, 0.1);
  }
  header {
    width: 100%;
    height: 60px;
    position: relative;
    .btn_area {
      left: 20px;
      .upload_song_btn {
        -webkit-border-radius: 20px;
        border-radius: 20px;
        cursor: pointer;
      }
    }

    .song {
      border-bottom: 1px solid #e5e5e5;

      &:last-child {
        border-bottom: none;
      }
      //   &:hover {
      //     background: #f4f4f4;
      //   }
      //   &.current {
      //     background: #f4f4f4;
      //   }
      .list_content {
        display: flex;
        font-size: 14px;
        line-height: 49px;
        .play {
          display: inline-block;
          width: 11px;
          height: 13px;
          cursor: pointer;
          background: url("../assets/img/play.png") center center no-repeat;
          background-size: 11px 13px;
          margin-top: 18px;
        }
        .pause {
          display: inline-block;
          width: 11px;
          height: 13px;
          cursor: pointer;
          background: url("../assets/img/pause.png") center center no-repeat;
          background-size: 11px 13px;
          margin-top: 18px;
        }
      }
      .fm_info {
        width: 280px;
        cursor: pointer;
        @include textOverflow;
        span {
          display: inline-block;
          width: 30px;
          margin: 0 6px;
          vertical-align: top;
          text-align: center;
          color: #999;
          @include textOverflow;
        }
      }
      .fm_handle {
        width: 186px;
        font-size: 14px;
        text-align: right;
        a {
          color: #333;
          i {
            margin: 0 0 0 8px;
          }
          &:first-child {
            margin: 0 15px 0 0;
          }
          &:last-child {
            margin: 0 20px 0 0;
          }
        }
      }
      .fm_progress {
        //flex: 1;
        color: #999;
        text-align: center;
        &.uploading {
          font-size: 12px;
        }
        &.fail {
          color: #ff0000;
        }
        .progress_bg {
          display: inline-block;
          width: 60px;
          height: 6px;
          background: #e0e0e0;
          border-radius: 3px;
          vertical-align: top;
          margin: 22px 8px 0;
          text-align: left;
          .progress {
            display: inline-block;
            height: 6px;
            background: #169af3;
            border-radius: 3px;
            vertical-align: top;
          }
        }
      }
      &:last-child {
        border-bottom: none;
      }
      .fm_status {
        &.passed {
          color: #369b04;
        }
        &.fail {
          color: #ff0000;
          i.icon {
            cursor: pointer;
            margin: 0 0 0 10px;
            vertical-align: middle;
          }
          .icon_arrow {
            // display:none;
            visibility: hidden;
            position: absolute;
            top: 50px;
            // left:-35px;
            right: -45%;
            max-width: 200px;
            padding: 5px 8px;
            font-size: 12px;
            line-height: 16px;
            border-radius: 5px;
            // min-height:30px;
            color: #f47979;
            background: #fff8f8;
            border: 1px solid #fcd4d4;
            z-index: 299;
            i {
              position: absolute;
              top: -6px;
              left: 50%;
              width: 9px;
              height: 6px;
              // background:red;
              //background-image: url("../assets/images/arrow_top.jpg");
              background-size: 9px 6px;
              background-position: top center;
              background-repeat: no-repeat;
            }
          }
          .currentShow {
            visibility: visible;
          }
        }
      }
      //   &:hover {
      //     background: #f9f9f9;
      //   }
      //   &.current {
      //     background: #f9f9f9;
      //   }
    }
  }
  .main {
    margin-top: 5px;
    .edit {
      margin-left: 20px;
      .row {
        position: relative;
        display: flex;
        margin-top: 20px;
        height: 40px;
        > div {
          position: relative;
          height: 100%;
        }
        .left {
          flex-basis: 100px;
          font-size: 16px;
          color: #000000;
          .label {
          }
        }
        .right {
          font-size: 16px;
          .el-select {
            width: 470px;
          }
          .radio {
            line-height: 40px;
          }
          .tip {
            p {
              font-size: 14px;
              color: #888888;
            }
          }
          .text {
            width: 450px;
            height: auto;
            min-height: 38px;
            line-height: 38px;
            padding: 0 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            font-size: 16px;
          }
          .textarea {
            width: 470px;
          }
          textarea {
            height: auto;
            min-height: 35px;
            line-height: 35px;
            padding: 0 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            font-size: 16px;
          }
          .btn {
            float: left;
            width: 140px;
            height: 40px;
            font-size: 16px;
            text-align: center;
            line-height: 40px;
            border-radius: 20px;
            cursor: pointer;
          }
          .submit {
            background-color: #0090ff;
            color: #fff;
            margin-right: 20px;
          }
          .back {
            border: 1px solid rgba(0, 0, 0, 0.1);
            color: #000;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/EditSong.vue